<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name {{ keyName }}
        span.validation-label(v-if="required == true") 必須
        span.option-text.font-strong-color(v-if="optionText") {{ optionText }}
        slot(name="question")

    .register-value.form-input-radios
      label.register-radio-label(v-for="(option, index) in options")
        // first input
        .radio(v-if="index == 0")
          input.register-radio-form(v-model="_value" type="radio" :name="name" :value="option.value"
            @change="onChange"
            v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName : keyName")
          span.register-radio-text {{ option.label }}
        // other input
        .radio(v-else)
          input.register-radio-form(v-model="_value" type="radio" :name="name" :value="option.value" @change="onChange")
          span.register-radio-text {{ option.label }}

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputRadio extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string | number | boolean;

  /** リスト項目 */
  @Prop()
  options!: Array<{ value: number | string | boolean; label: string }>;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** 説明文 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  optionText!: string;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string | number | boolean {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string | number | boolean) {
    this.$emit("input", newValue);
    return;
  }

  public onChange(): void {
    this.$emit("change");
    return;
  }
}
</script>

<style lang="scss" scoped>
.option-text {
  margin-left: 8px;
}
.right-side {
  margin-left: auto;
}
// ラジオボタンは横幅に応じてラップする
.form-input-radios {
  flex-wrap: wrap;
}
</style>
